import { SHOW_DIALOG } from '../constants/action-types';
export const show = (type, dialogProps) => ({
    type: SHOW_DIALOG,
    payload: {
        type,
        dialogProps,
    },
});
